import { MutationTree } from "vuex";
import { SessionsState } from "./types";
import { getDefaultState } from "./state";
import Vue from "vue";

export const mutations: MutationTree<SessionsState> = {
	setResourceSessionId(
		state,
		{ resourceId, sessionId, regionId }: { resourceId: number; sessionId: string; regionId?: number }
	) {
		if (!state.sessions[regionId]) {
			Vue.set(state.sessions, regionId, { 2: "", 3: "" });
		}

		Vue.set(state.sessions[regionId || 0], resourceId, sessionId);
	},
	clearResourceSessionId(state, resource: number | { id: number; regionId: number }) {
		let regionId: number = 0, resourceId: number = null;

		if (typeof resource == "object") {
			regionId = resource.regionId;
			resourceId = resource.id;
		} else {
			resourceId = resource;
		}

		if (state.sessions[regionId]) {
			Vue.delete(state.sessions[regionId], resourceId);
		}
	},
	setResourceStatus(state, status: number) {
		state.requestStatus = status;
	},
	resetState(state) {
		Object.assign(state, getDefaultState());
	}
};
